'use client';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ui/components/ui/dialog';

import { ShareOptionsContent, ShareOptionsContentProps } from './ShareOptionsContent';

export interface ShareOptionsDialogProps extends ShareOptionsContentProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

export function ShareOptionsDialog({
  isOpen,
  onClose,
  profileUrl,
  userName,
  translations,
  title = 'Share via'
}: ShareOptionsDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="sr-only">Share options</DialogDescription>
        </DialogHeader>

        <ShareOptionsContent
          profileUrl={profileUrl}
          userName={userName}
          translations={translations}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
